import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { HeartPlus } from '@/components/icons';
import { AiFillHeart } from 'react-icons/ai';
import useWishlist from '@/store/wishlist.store';
import { toast } from 'sonner';
import { event_toggle_wishlist, update_wishlists_event } from '@/utils/gtm';

const ManageWishlist = ({ sku, product }) => {
  const t = useTranslations('common');
  const { toggleWishlist, wishlist, products } = useWishlist((state) => state);

  const isFav = useMemo(() => wishlist?.includes(sku), [wishlist, sku]);

  const toggleFavorite = () => {
    toggleWishlist(sku, product);
    if (isFav) {
      update_wishlists_event(
        products
          .filter((info) => info?.sku !== product?.sku)
          ?.filter((info) => !!info)
      );
      event_toggle_wishlist(product, 'remove_from_wishlist');
      toast.info(t('product_removed_from_favorite'));
    } else {
      update_wishlists_event([...products, product]);
      event_toggle_wishlist(product, 'add_to_wishlist');
      toast.success(t('product_added_to_favorite'));
    }
  };

  return (
    <button
      onClick={toggleFavorite}
      className='hover:text-primary/90 flex cursor-pointer items-center gap-2 transition max-md:text-sm max-sm:text-xs'
    >
      {isFav ? (
        <AiFillHeart className='text-primary size-7.5 max-sm:size-4' />
      ) : (
        <HeartPlus className='size-7.5 max-md:size-6' />
      )}
      <span>{t('add_to_favorites_key')}</span>
    </button>
  );
};

export default ManageWishlist;
